/**
 * @fileoverview QuicksearchSection — section header ("Recent searches",
 * "Apps", …) + a `bp6-menu` body. Foundry mapping:
 * `quicksearch-shared-components__header__wp9kvm` + `bp6-menu`.
 */

import { Menu } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface QuicksearchSectionProps {
  title: ReactNode;
  /** Right slot of the header (e.g. a "View all" link). */
  headerAction?: ReactNode;
  /** <QuicksearchResultItem /> children. */
  children: ReactNode;
  className?: string;
}

export function QuicksearchSection({
  title,
  headerAction,
  children,
  className,
}: QuicksearchSectionProps): ReactElement {
  return (
    <div data-testid="quicksearch-section" className={["bp-quicksearch-section", className].filter(Boolean).join(" ")}>
      <div className="bp-quicksearch-section-header">
        <div className="bp-quicksearch-section-title">{title}</div>
        {headerAction && <div>{headerAction}</div>}
      </div>
      <Menu className="bp-quicksearch-menu">{children}</Menu>
    </div>
  );
}
